export default __webpack_public_path__ + "static/media/2.1af28052.jpg";